module.exports = __webpack_public_path__ + "img/sumary_grid-v2.46ed2376.svg";